@if (simulationUnavailable) {
  <div class="simulation-unavailable-hint">
    <fa-icon [icon]="faExclamationCircle"></fa-icon>
    {{ unavailableMessage }}
  </div>
} @else {
  <div class="simulations">
    @for (simulation of simulations; track simulation) {
      <div class="simulation">
        @if (simulationConfigs[simulation]; as sim) {
          <div class="simulation-header" (click)="toggleSimulation(simulation)">
            <div class="label">{{ sim.label }}
              @if (simulationDescriptions[simulation]) {
                <fa-icon [icon]="faQuestionCircle" size="lg" class="info" [pTooltip]="simulationDescriptions[simulation]"></fa-icon>
              }
            </div>
            <div class="switcher">
              <p-toggle-switch [(ngModel)]="sim.enabled" (onChange)="adjustConsoleManipulations()"></p-toggle-switch>
            </div>
        </div>
      }
      <div class="simulation-content">
        @if (simulation === 'myopia') {
          <div class="myopia">
            <div class="degree">
              <div class="label">{{ simulationConfigs['myopia'].config.degree * 100 }} %</div>
              <p-slider class="slider" [(ngModel)]="simulationConfigs['myopia'].config.degree" [min]="0.0" [max]="1.0" [step]="0.1" (onChange)="adjustConsoleManipulations()"></p-slider>
            </div>
          </div>
        }
        @if (simulation === 'glare') {
          <div class="glare">
            <div class="degree">
              <div class="label">{{ simulationConfigs['glare'].config.degree * 100 }} %</div>
              <p-slider class="slider" [(ngModel)]="simulationConfigs['glare'].config.degree" [min]="0.0" [max]="1.0" [step]="0.1" (onChange)="adjustConsoleManipulations()"></p-slider>
            </div>
          </div>
        }
        @if (simulation === 'contrast') {
          <div class="contrast">
            <div class="degree">
              <div class="label">{{ simulationConfigs['contrast'].config.degree * 100 }} %</div>
              <p-slider class="slider" [(ngModel)]="simulationConfigs['contrast'].config.degree" [min]="0.0" [max]="1.0" [step]="0.1" (onChange)="adjustConsoleManipulations()"></p-slider>
            </div>
          </div>
        }
      </div>
    </div>
  }
  </div>
}
